import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import css from 'react-css-modules';
import {ICONS_PER_ROW} from '../settings';
import SetsResultsIcon from './SetsResultsIcon';
import SetsResultsPlaceholder from './SetsResultsPlaceholder';
import fillWithPlaceholders from 'utils/components/fillWithPlaceholders';

const SetsResults = createReactClass({
  propTypes: {
    onIconClicked: PropTypes.func.isRequired,
    query: PropTypes.string,
    hits: PropTypes.array,
    hitsPerPage: PropTypes.number,
    count: PropTypes.number,
    iconsPerRow: PropTypes.number,
  },

  getDefaultProps() {
    return {
      iconsPerRow: ICONS_PER_ROW,
    };
  },

  title() {
    const {query, hitsPerPage, count} = this.props;

    let titleElement = null;

    if (hitsPerPage < count) {
      titleElement = <p className="text-base text-muted m-xs-b-lg">Found {count} results for <strong>&ldquo;{query}&rdquo;</strong> (showing first {hitsPerPage})</p>;
    } else {
      titleElement = <p className="text-base text-muted m-xs-b-lg">Found {count} results for <strong>&ldquo;{query}&rdquo;</strong></p>;
    }

    return titleElement;
  },

  render() {
    if (!this.props.query) {
      return null;
    }

    const {hits} = this.props;

    let icons = hits.map((result) => {
      return (
        <SetsResultsIcon
          key={result.id}
          name={result.name}
          unicodeChar={result.unicode_char}
          onClicked={this.props.onIconClicked}
          iconSet={{name: result.icon_set.name, slug: result.icon_set.slug}}
        />
      );
    });

    icons = fillWithPlaceholders(
      icons,
      {placeholder: SetsResultsPlaceholder, multipleOf: this.props.iconsPerRow}
    );

    return (
      <div>
        {this.title()}

        <ul className="grid-assets grid-assets-animate grid-assets-sm-8">
          {icons}
        </ul>
      </div>
    );
  },
});

export default SetsResults;



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/components/SetsResults.js